import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const routePrefix = "/minimaleeisenperdossier/";

const MinimaleEisenPerDossierApi = {
	getByDossier(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	save(minimaleEisen, documenten) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return axios.put(serviceUrl, {
			item: minimaleEisen,
			documenten
		}, {
				headers: {
					'accept': 'application/json'
				}
			});
	}
};

export default MinimaleEisenPerDossierApi;
